import middlewares from '@/core/services/routeMiddlewares.service';
import Login from '@/login/views/index.view.vue';

const LoginRouter = {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: middlewares.ifNotAuthenticated,
};

export default [
    LoginRouter,
];
